import React, { useState, useContext } from "react";
import {useForm, FormProvider} from "react-hook-form";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

import * as CustomStyles from '../../styles/CustomStyles';
import * as EmployeeFragment from './EmployeeFragmentComponent';
import EmployeeAuthorizations from './EmployeeAuthorizationsComponent';
import {TabPanel, a11yProps} from "../../custom/CustomTabPanelComponent";
import BucketContext from "../../context/BucketContext";
import {ContractMuncaStatus} from '../../constants/Consts';
import * as AFFragment from '../../custom/AFFragment';
import * as DateHelper from '../../util/DateHelper';

const useConfirmDialog = () => {
    const [open, setOpen] = React.useState(false);
    const [patchEmployee, setPatchEmployee] = React.useState(null);
    const [employee, setEmployee] = React.useState(null);

    const openDialog = (patchEmployee, employee) => {
        setPatchEmployee(() => e => patchEmployee(e));
        setEmployee(employee);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleSubmit =() => {
        patchEmployee(employee);
    }

    const props = {
      open,
      handleClose,
      handleSubmit
    };
    return [openDialog, props];
};


const ConfirmCloseContract = ({open, handleClose, handleSubmit}) => {
    console.log('__ ConfirmCloseContract __');

    const handleConfirmSubmit = () => {
        handleClose();
        handleSubmit();
    }

    return(
        <React.Fragment>
            <Dialog open={open} onClose={handleClose} maxWidth='md'>
                <DialogTitle>
                    Confirmare
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                        >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        Confirmati Inchiderea Contractului!
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Inchide</Button>
                    <Button onClick={handleConfirmSubmit} color="error" >Confirmare</Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );
}


const TabBottomButtonBar = (props) => {
    return (
        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                <Button variant="outlined" type="submit" sx={{ marginRight: 1 }}> {props.buttonLabel} </Button>
            </Grid>
        </Grid>
    );
}


function EmployeeTabsRenderer(props) {
    console.log('EmployeeTabRenderer invoked');

    const bucketContext = useContext(BucketContext);

    const methods = useForm({
        defaultValues: {
            lEmployee: props.employee
        } 
    });
    const handleSubmit = methods.handleSubmit;

    const tabIndex = (!!bucketContext.bucket.employeeTabIndex && bucketContext.bucket.employeeTabIndex<=2) ? bucketContext.bucket.employeeTabIndex : 0;

    const [value, setValue] = React.useState(tabIndex);
    const handleTabChange = (event, newValue) => {
      setValue(newValue);
      bucketContext.setBucketValue( {employeeTabIndex: newValue} );
   };    


    const formatPersonalDataDates = (employee) => {
        if(DateHelper.isRoLocaleStringDate(employee.generalSection.dataNasterii)) 
        employee.generalSection.dataNasterii =  DateHelper.getDateFromString(employee.generalSection.dataNasterii).toISOString();
    };

    const handleSubmitpersonalData = (data) => {
        const employee = {
            id: data.lEmployee.id,
            employerId: data.lEmployee.employmentDetails.employerId,
            generalSection: data.lEmployee.generalSection,
            domiciliuStabil: data.lEmployee.domiciliuStabil,
            domiciliuFlotant: data.lEmployee.domiciliuFlotant
        };
        formatPersonalDataDates(employee);
        props.patchEmployee(employee);
    }

    const [openConfirmDialog, confirmDialogProps] = useConfirmDialog();
    const handleSubmitEmploymentData = (data) => {
        const employee = {
            id: data.lEmployee.id,
            employerId: data.lEmployee.employmentDetails.employerId,
            employmentDetails: data.lEmployee.employmentDetails
        }

        if(employee.employmentDetails.contractStatus === ContractMuncaStatus.Inchis) {
            openConfirmDialog(props.patchEmployee, employee);
        }
        else{
            props.patchEmployee(employee);
        }
    }


    return(
        <FormProvider {...methods} > 

            <ConfirmCloseContract {...confirmDialogProps}/>

            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleTabChange} aria-label="scrollable tabs" variant="scrollable" scrollButtons="auto">
                        <Tab label="Date Personale" {...a11yProps(0)} />
                        <Tab label="Date de Angajare" {...a11yProps(1)} />
                        <Tab label="Autorizatii" {...a11yProps(2)} />
                    </Tabs>
                </Box>

                <TabPanel value={value} index={0}>
                    <form onSubmit={handleSubmit( handleSubmitpersonalData )} id={'personalDataTabForm'}>
                        <EmployeeFragment.RenderPersonalDataSection />
                        <EmployeeFragment.RenderDomiciliuStabil />
                        <EmployeeFragment.RenderDomiciliuFlotant />

                        <TabBottomButtonBar 
                            employeeId={props.employee.id}
                            employerId={props.employee.employmentDetails.employerId} 
                            buttonLabel='Salveaza Date Personale' 
                        />
                    </form>
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <form onSubmit={handleSubmit( handleSubmitEmploymentData )} id={'employmentDataTabForm'}>
                        <EmployeeFragment.RenderEmployment 
                            employers={props.employers} 
                            corCodes={props.corCodes}
                        />

                        <TabBottomButtonBar 
                                employeeId={props.employee.id} 
                                employerId={props.employee.employmentDetails.employerId} 
                                buttonLabel='Salveaza Date de Angajare' 
                            />
                    </form>
                </TabPanel>

                <TabPanel value={value} index={2}>
                        <EmployeeAuthorizations 
                            employee={props.employee}
                            authorizations={props.authorizations}
                            authorizationsDataStatus={props.authorizationsDataStatus}
                        />
                </TabPanel>
            </Box>

            <AFFragment.UpdateDetailsSection entity={props.employee}/>

        </FormProvider>

    ); 
}

export default EmployeeTabsRenderer;